import { useQuery } from '@tanstack/react-query'
import { accessControlApi } from '../api/access-control.client'

export const SUBJECTS_QUERY_KEY = ['access-control', 'subjects'] as const

export function useSubjectsQuery() {
  return useQuery({
    queryKey: SUBJECTS_QUERY_KEY,
    queryFn: () => accessControlApi.listSubjects(),
    // The catalog changes rarely; cache it generously across the section.
    staleTime: 5 * 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
